export default __webpack_public_path__ + "static/semafor-ec9756db3055c92ecacc135baeb4bb04.svg";